<div class="min-h-[80vh] flex items-center justify-center px-4 py-16 bg-station-cream">
  <div class="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
    <h1 class="text-3xl font-bold mb-2 text-flap-black">Forgot your password?</h1>

    @if (sent()) {
      <p class="text-rail-gray mb-8">
        If an account exists for <span class="font-semibold">{{ email() }}</span>, we sent it a
        password reset link. Check your inbox (and spam folder). The link expires in one hour.
      </p>
      <p class="text-center text-sm text-rail-gray">
        <a routerLink="/login" class="text-signal-orange font-semibold hover:underline">Back to log in</a>
      </p>
    } @else {
      <p class="text-rail-gray mb-8">Enter your email address and we will send you a reset link.</p>

      <form (ngSubmit)="submit()" class="space-y-5">
        <div>
          <label for="email" class="block text-sm font-semibold text-flap-black mb-1">Email</label>
          <input
            id="email"
            type="email"
            autocomplete="email"
            required
            [ngModel]="email()"
            (ngModelChange)="email.set($event)"
            name="email"
            class="w-full px-4 py-3 rounded-lg border-2 border-border-subtle focus:border-signal-orange outline-none transition-colors"
          />
        </div>

        @if (error(); as err) {
          <p class="text-sm text-signal-orange">{{ err }}</p>
        }

        <button
          type="submit"
          [disabled]="submitting()"
          class="w-full px-6 py-3 bg-signal-orange text-white rounded-lg font-semibold hover:bg-signal-orange/90 transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer"
        >
          {{ submitting() ? 'Sending…' : 'Send reset link' }}
        </button>
      </form>

      <p class="mt-6 text-center text-sm text-rail-gray">
        Remembered it?
        <a routerLink="/login" class="text-signal-orange font-semibold hover:underline">Log in</a>
      </p>
    }
  </div>
</div>